import React from 'react';
import moment from 'moment';
import s from './style.module.css';

class DatetimepickerHeader extends React.Component {

	render() {
		return (
			<div className={s.wrapper}>
				<div className={s.dayWrapper}>
					<div className={s.today}>Today</div>
					<div className={s.day}>{moment().format('dddd')}</div>
				</div>
				<div className={s.yearWrapper}>
					<div className={s.year}>{moment().format('YYYY')}</div>
					<div className={s.month}>{moment().format('DD MMMM')}</div>
				</div>
			</div>
		);
	}
}


export default DatetimepickerHeader; 